import React from 'react'
import MembershipPricingTableForm from '../../features/MembershipPricing/MembershipPricingTableForm'

function MembershipPricing() {
  return (
    <MembershipPricingTableForm/>
  )
}

export default MembershipPricing